import { NgModule } from "@angular/core";
import { SyncBarComponent } from "./sync-bar.component";
import { SharedModule } from "app/shared.module";

@NgModule({
    declarations: [SyncBarComponent],
    imports: [SharedModule],
    exports: [SyncBarComponent]
})
export class SyncBarModule { }
